import { css } from 'lit';
export default css`:host{display:block}.tabs__list{display:flex;border-bottom:1px solid var(--color-neutral-600);overflow-x:auto;white-space:nowrap}
`;
